import { ComponentChildren, FunctionalComponent, h } from 'preact';
import { LinkProps, ServiceCardLink } from '../general/ServiceCardLink';

export interface UnparsedServiceCardDesktop {
	headline: string;
	cardType: string;
	linkMore?: string;
	highlighted: string;
	children: ComponentChildren;
}
export interface ParsedServiceCardDesktop {
	headline: {
		label: string;
	};
	cardType: {
		size: 'small' | 'large';
		backgroundColor: boolean;
	};
	highlighted: boolean;
	linkMore?: LinkProps;
}

const parseProps = (unparsedProps: UnparsedServiceCardDesktop): ParsedServiceCardDesktop => {
	const parsedProps: ParsedServiceCardDesktop = {
		headline: JSON.parse(unparsedProps.headline),
		cardType: JSON.parse(unparsedProps.cardType),
		highlighted: JSON.parse(unparsedProps.highlighted),
		linkMore: unparsedProps.linkMore ? JSON.parse(unparsedProps.linkMore) : null,
	};
	return parsedProps;
};

export const ServiceCardDesktop: FunctionalComponent<UnparsedServiceCardDesktop> = (unparsedProps) => {
	const props = parseProps(unparsedProps);
	const { headline, cardType, linkMore, highlighted } = props;
	return (
		<div className={`SP-ServiceCard SP-ServiceCard__${cardType.size}--desktop`}>
			<h2 className="SP-ServiceCard__headline--desktop">{headline.label}</h2>
			{unparsedProps.children}
			{linkMore && <ServiceCardLink {...linkMore} highlighted={highlighted} />}
		</div>
	);
};
